import React from 'react'
import './StyledBgContainer.css'
import { Container } from '@mui/material'

interface StyledBgContainerProps {
  children: React.ReactNode
}

const StyledBgContainer = ({ children }: StyledBgContainerProps) => {
  return (
    <div className="bg-container">
      <Container maxWidth="xl">{children}</Container>
    </div>
  )
}

export default StyledBgContainer
